import { useContext } from 'react';
import { VideoViewerModalContext } from '../providers/VideoViewerModalContext';

/**
 * Hook to access the VideoViewerModal context
 * Must be used within VideoViewerModalProvider
 * @returns VideoViewerModalContextValue with open and close methods
 */
export function useVideoViewerModal() {
  const ctx = useContext(VideoViewerModalContext);
  if (!ctx) {
    throw new Error(
      'useVideoViewerModal must be used within VideoViewerModalProvider'
    );
  }
  return ctx;
}
